import { PaymentStatus, TransactionStatus } from "./financials-types";
import { client } from "../../client";

export interface PaymentDetails {
  id: string;
  resolvedDttm: string | null;
  createdDttm: string;
  method: string;
  status: PaymentStatus;
  transactionStatus: TransactionStatus;
  reference: string | null;
  description: string | null;
  amount: string;
  currency: string;
}

export interface AccountPayments {
  results: PaymentDetails[];
}

export const getAccountPayments = (
  key: string,
  {
    page,
    size,
    accountNumber,
  }: { page: number; size: number; accountNumber: string },
) => {
  const params = { page: String(page), size: String(size) };
  return client
    .get<AccountPayments>(
      `accounts/${accountNumber}/payments?${new URLSearchParams(
        params,
      ).toString()}`,
    )
    .then((response) => {
      return {
        results: response?.data?.results,
        totalCount: response?.headers["x-total-count"],
      };
    });
};

export const getAccountPayment = (
  key: string,
  { accountNumber, paymentId }: { accountNumber: string; paymentId: string },
) => {
  return client
    .get<PaymentDetails>(`accounts/${accountNumber}/payments/${paymentId}`)
    .then((res) => {
      return res.data;
    });
};
